import cx from 'classnames'
import styles from './styles.module.scss'
import { CSSProperties, FC } from 'react'
import colors from '@xo-union/tk-ui-colors/lib/variables.css'

interface PageControlProps {
  pages: number
  onPageSelected: (index: number) => void
  current: number
  className?: string
  controlStateColors?: {
    unselectedPageDot: string
    selectedPageDot: string
    hoverStateDotBorder: string
  }
}

export const PageControl: FC<PageControlProps> = ({
  pages,
  onPageSelected,
  current,
  className,
  controlStateColors,
}) => {
  const dots = Array.from({ length: pages }, (_, i) => i)

  const { unselectedPageDot, selectedPageDot, hoverStateDotBorder } = controlStateColors ?? {
    unselectedPageDot: colors.varWhite,
    selectedPageDot: colors.varBackgroundDark,
    hoverStateDotBorder: colors.varNeutral200,
  }

  return (
    <ol className={cx(styles.carouselIndicators, className)}>
      {dots.map((i, index) => {
        const activeClass = current == index ? styles.active : ''
        return (
          <li
            onClick={() => onPageSelected(index)}
            key={i}
            aria-label={`${index + 1} of ${pages}`}
            style={
              {
                '--unselectedPageDot': unselectedPageDot,
                '--selectedPageDot': selectedPageDot,
                '--hoverStateDotBorder': hoverStateDotBorder,
              } as CSSProperties
            }
            className={cx(styles.carouselIndicator, activeClass)}
          />
        )
      })}
    </ol>
  )
}
